export default function getCourseFromCourseId(courseList, courseId) {
  if (courseList === null || courseList === undefined) return null;
  return courseList.find((course) => course._id === courseId);
}
